const RevitBimCourse = {
    id: "revit-bim",

    name: "Revit BIM Automation & Customization",
syllabusPdf: "/syllabus/Revit-API-Syllabus.pdf",

    hero: {
        title: "Revit BIM Automation & Customization",
        subtitle: "Live & Interactive Online Training",
        logo: "/revit-bim-logo.webp",

        points: [
            "Master Revit BIM Automation through API programming with C# .NET. Automate modeling, parameter control, scheduling, documentation, and data extraction in BIM workflows.",

            "Perfect for architects, BIM engineers, and construction professionals aiming for high-paying roles and rapid career advancement through advanced Revit API-based automation and customization skills.",

            "Transition from manual BIM tasks to high-efficiency, code-driven workflows using C# and Autodesk Revit API, empowering you to build intelligent, reusable BIM tools.",

            "Start from programming basics, making it easy for non-coders and beginners to learn automation step by step.",

            "Learn from industry experts currently working on large-scale AEC (Architecture, Engineering & Construction) projects in top-tier firms — with real-world examples and career guidance."
        ]
    },

    highlights: [
        {
            title: "High Salary",
            description:
                "“For REVIT Design Engineers with 4 to 5 years of experience, the average CTC ranges from 5 Lakhs to 10 Lakhs. However, REVIT Developers with the same experience can command CTCs of 30 Lakhs to 40 Lakhs.”"
        },
        {
            title: "Good Demand",
            description:
                "“While Revit Design is a well-known skill among Architect and engineers, there is intense competition for design jobs. On the other hand, Revit BIM Automation & Customization is a niche expertise, with only a few engineers.”"
        },
        {
            title: "Easier To Learn",
            description:
                "“While CAD/BIM Design is generally easier to learn, CAD/BIM Automation & Customization can be more challenging. With our extensive experience in this field, we aim to simplify the process for you with our step by step training.”"
        }
    ],

    whyLearn: [
        {
            title: "Automate Repetitive BIM Tasks",
            description:
                "Eliminate time-consuming manual work like creating sheets, placing views, updating parameters, and modifying families using custom Revit add-ins."
        },
        {
            title: "Boost Productivity in Real-World Projects",
            description:
                "With automation, you can handle large-scale projects faster and with fewer errors — crucial for tight deadlines in AEC industries."
        },
        {
            title: "Develop Custom Revit Tools",
            description:
                "Build tailored tools and plugins for your firm’s specific workflows — from clash detection utilities to auto-tagging systems, saving hundreds of work hours."
        },
        {
            title: "Get High-Demand Job Opportunities",
            description:
                "Revit API developers with C# skills are in high demand by BIM consulting firms, architecture companies, and construction tech startups."
        },
        {
            title: "Enhance Your BIM Skillset Beyond Modeling",
            description:
                "Stand out from regular BIM modelers by adding powerful programming and automation skills to your resume."
        },
        {
            title: "Solve Real-Time Industry Problems",
            description:
                "Create tools for instant quantity takeoffs, data extraction to Excel, automated dimensioning, and IFC management — real solutions for real needs."
        },
        {
            title: "Future-Proof Your Career in AEC Tech",
            description:
                "With the rise of generative design, digital twins, and smart buildings, automation is the future — learning Revit API ensures you stay ahead."
        },
        {
            title: "Start from Basics — No Prior Coding Needed",
            description:
                "Revit API using C#.NET can be learned step-by-step even if you’re from a non-programming background — ideal for architects and engineers."
        },
        {
            title: "Contribute to Open-Source & Community Tools",
            description:
                "Join the growing Revit API developer community, contribute to GitHub projects, and build a reputation in the AEC tech space."
        },
        {
            title: "Build a Freelance or Consulting Career",
            description:
                "Custom Revit tool development is a highly paid niche. Many professionals turn their skills into freelance or product development careers."
        }
    ],

   syllabus: [
    {
        name: "C#.NET",
        modules: [
            {
                number: 1,
                title: "Core Programming Fundamentals",
                topics: [
                    "Environment Setup",
                    "Basic Syntax",
                    "Program Structure",
                    "Data Types",
                    "Variables",
                    "Constants",
                    "Modifiers",
                    "Statements",
                    "Operators",
                    "Using Math Functions"
                ]
            },
            {
                number: 2,
                title: "Control Flow",
                topics: [
                    "Decision Making (if, switch, etc.)",
                    "Loops (for, while, do-while, foreach)"
                ]
            },
            {
                number: 3,
                title: "Working with Data",
                topics: [
                    "Strings",
                    "Date & Time",
                    "Arrays (1D, 2D, 3D)",
                    "Functions",
                    "Arguments",
                    "Return Types",
                    "In, out, & ref Parameters"
                ]
            },
            {
                number: 4,
                title: "Collections & Data Structures",
                topics: [
                    "List",
                    "ArrayList",
                    "Dictionary",
                    "Hashtable",
                    "Struct",
                    "Enum"
                ]
            },
            {
                number: 5,
                title: "Object-Oriented Programming",
                topics: [
                    "Classes & Objects",
                    "Constructor & Destructor",
                    "Access Levels (public, private, etc.)",
                    "Stack vs Heap Memory",
                    "Static Class & Static Methods"
                ]
            },
            {
                number: 6,
                title: "Advanced OOP Concepts",
                topics: [
                    "Abstract Class & Abstract Methods",
                    "Interfaces",
                    "Inheritance",
                    "Single",
                    "Multiple",
                    "Multilevel",
                    "Polymorphism",
                    "Method Overloading",
                    "Method Overriding"
                ]
            },
            {
                number: 7,
                title: "Error & File Handling",
                topics: [
                    "Exception Handling",
                    "Files & Directory Handling"
                ]
            },
            {
                number: 8,
                title: "Application Development",
                topics: [
                    "Creating Console Applications",
                    "Windows Forms Application",
                    "Form Controls (TextBox, Button, Label, etc.)",
                    "Dialog Boxes",
                    "Advanced Form Design",
                    "Event Handling"
                ]
            },
            {
                number: 9,
                title: "Advanced C# Features",
                topics: [
                    "Class Library & DLL Creation",
                    "Interacting with Notepad Files",
                    "Interacting with Excel Files"
                ]
            },
            {
                number: 10,
                title: "Visual Studio Skills",
                topics: [
                    "Using Visual Studio IDE Features",
                    "Debugging",
                    "IntelliSense",
                    "Solution & Project Management"
                ]
            }
        ]
    },

    {
        name: "Revit BIM",
        modules: [
            {
                number: 1,
                title: "Revit API Concepts & Architecture",
                topics: [
                    "Visual Studio Project Creation",
                    "Understanding Revit Architecture",
                    "Interacting with Revit using C#.NET"
                ]
            },
            {
                number: 2,
                title: "Writing First Code",
                topics: [
                    "Writing & Explaining the First Revit Add-in",
                    "Debugging in Visual Studio",
                    "Manifest File Creation",
                    "Build Events Setup"
                ]
            },
            {
                number: 3,
                title: "Element Selection",
                topics: [
                    "Selecting Elements in Revit",
                    "Retrieving Properties of Selected Elements",
                    "Using ISelectionFilter for Pre-Filtering",
                    "Unit Conversions with UnitUtils"
                ]
            },
            {
                number: 4,
                title: "Get and Set Elements",
                topics: [
                    "Basics of Revit Element Filters",
                    "Get Elements Using Filters",
                    "Modify (Set) Elements Using Filters"
                ]
            },
            {
                number: 5,
                title: "Advanced Filtering Techniques",
                topics: [
                    "Quick Filters",
                    "Logical Filters",
                    "LINQ-Based Filtering",
                    "Retrieving Elements or ElementIds"
                ]
            },
            {
                number: 6,
                title: "Transactions",
                topics: [
                    "Creating a Single Transaction",
                    "Managing Multiple Transactions with Transaction Groups"
                ]
            },
            {
                number: 7,
                title: "Element Creation (2D & 3D)",
                topics: [
                    "Create Single Wall",
                    "Create Multiple Walls",
                    "Floor Creation",
                    "Filled Region Creation (2D)"
                ]
            },
            {
                number: 8,
                title: "Element Transformation",
                topics: [
                    "Move Elements",
                    "Rotate Elements",
                    "Mirror Elements"
                ]
            },
            {
                number: 9,
                title: "Working with Revit Geometry",
                topics: [
                    "Understanding GeometryElement, GeometryObject, GeometryInstance",
                    "Accessing Geometric Properties of Elements"
                ]
            },
            {
                number: 10,
                title: "Project Template Parameters",
                topics: [
                    "Parameter Object Hierarchy",
                    "Retrieving Parameter Values",
                    "Setting Parameter Values"
                ]
            },
            {
                number: 11,
                title: "Revit Families (In-Project Use)",
                topics: [
                    "Load Family into Project",
                    "Use of IFamilyLoadOptions",
                    "Placing Families in Revit"
                ]
            },
            {
                number: 12,
                title: "Revit Families (Family Template Editing)",
                topics: [
                    "Create New Family Types and Parameters",
                    "Set Parameter Values in Families",
                    "Save Family & Load into Project"
                ]
            },
            {
                number: 13,
                title: "Revit UI Customization",
                topics: [
                    "Create Ribbon Tabs in Revit",
                    "Add Panels and Buttons",
                    "Create Dropdown Buttons",
                    "Embed Commands in External Applications"
                ]
            },
            {
                number: 14,
                title: "Windows Forms Integration",
                topics: [
                    "Create Windows Forms UI",
                    "Modeless WinForms in Revit",
                    "Access and Modify Revit Elements via Forms"
                ]
            },
            {
                number: 15,
                title: "Revit Events",
                topics: [
                    "Database Events",
                    "UI Events"
                ]
            },
            {
                number: 16,
                title: "Handling Revit Failures",
                topics: [
                    "Failure Processing Overview",
                    "IFailurePreProcessor",
                    "IFailureProcessor",
                    "Handling and Suppressing Failures Gracefully"
                ]
            },
            {
                number: 17,
                title: "Extensible Storage",
                topics: [
                    "Creating and Assigning Values",
                    "Managing Custom Data Storage",
                    "Deleting and Retrieving E-Storage"
                ]
            },
            {
                number: 18,
                title: "Revit ↔ Excel Integration",
                topics: [
                    "Read & Write Revit Parameters via Excel",
                    "Exporting Element Data to Excel"
                ]
            },
            {
                number: 19,
                title: "Plugin Installer Creation",
                topics: [
                    "Create Professional .MSI Installer for Revit Add-ins"
                ]
            },
            {
                number: 20,
                title: "Project Support",
                topics: [
                    "Hands-on Project Development Assistance"
                ]
            },
            {
                number: 21,
                title: "Career Support",
                topics: [
                    "Resume Building for Revit Automation Profiles",
                    "Job Assistance & Interview Guidance",
                    "Career Roadmap in BIM Automation"
                ]
            }
        ]
    }
],

    faq: [
        {
            question: "What is REVIT API?",
            answer:
                "Revit API (Application Programming Interface) is a set of tools and functions that enable users to customize and automate Autodesk Revit, a building information modeling (BIM) software. With the Revit API, you can develop custom applications and scripts to enhance the functionality of Revit, automate tasks, and integrate it with other software, making BIM processes more efficient and tailored to specific project needs."
        },
        {
            question: "How Much Salary?",
            answer:
                "REVIT Developers often receive significantly higher salaries compared to REVIT designers. This is because they can customize REVITs and create automation tools that can perform tasks that would be challenging for many individuals to accomplish without such tools.\n\nFor a detailed explanation, please view the video located at this page."
        },
        {
            question: "I Have REVIT Design Experience",
            answer:
                "Having REVIT design experience is an advantage. It allows you to fully leverage your design skills and familiarity with REVIT tools.\n\nYou can adeptly assess and make informed decisions about which aspects to automate and the value that automation brings."
        },
        {
            question: "Job Guaranteed?",
            answer:
                "Generally No.\nSometimes Yes.\nPlease speak to the coordinator for more details."
        },
        {
            question: "Which Programming Language?",
            answer:
                "For other CAD tools such as REVIT, NX, AutoCAD, Solidworks, Inventor, etc., C#.NET or VB.NET are well-suited programming languages."
        },
        {
            question: "Job Opportunities?",
            answer:
                "This skill is quite rare, with a limited number of professionals available in the market compared to the growing demand. Consequently, the job opportunities in this field are in high demand and offer promising prospects."
        }
    ],

    videos: [
        {
            category: "What is CAD Customization? ( Explained using real project)",
            title: "CAD Customization And Automation Session",
            videoUrl:
                "https://www.youtube.com/embed/VpcpMwvQJy4?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=1\\&forigin=https%3A%2F%2Ffeesworth.com%2Fautodesk-revit-api-customization-automation-course%2F\\&aoriginsup=1\\&gporigin=https%3A%2F%2Ffeesworth.com%2Fautocad-api-customization-automation-online-courses%2F\\&vf=1"
        },
        {
            category: "CAD Customization & Automation",
            title: "What is CAD Customization and Automation?",
            videoUrl:
                "https://www.youtube.com/embed/0TB3m21GMO8?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=3\\&forigin=https%3A%2F%2Ffeesworth.com%2Fautodesk-revit-api-customization-automation-course%2F\\&aoriginsup=1\\&gporigin=https%3A%2F%2Ffeesworth.com\\&vf=1"
        },
        {
            category: "Revit API sample project Geometry creation",
            title: "Revit API Sample Project Geometry Concept Demo",
            videoUrl:
                "https://www.youtube.com/embed/YhbgQvxbJ98?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=5\\&forigin=https%3A%2F%2Ffeesworth.com%2Fautodesk-revit-api-customization-automation-course%2F\\&aoriginsup=1\\&gporigin=https%3A%2F%2Ffeesworth.com%2Fautocad-api-customization-automation-online-courses%2F\\&vf=1"
        },
        {
            category: "Revit API Project Family Placement",
            title: "Revit API Sample Project Family Placement",
            videoUrl:
                "https://www.youtube.com/embed/ls6QiHlP_4o?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=7\\&forigin=https%3A%2F%2Ffeesworth.com%2Fautodesk-revit-api-customization-automation-course%2F\\&aoriginsup=1\\&gporigin=https%3A%2F%2Ffeesworth.com%2Fautocad-api-customization-automation-course%2F\\&vf=1"
        },
        {
            category: "Automated Column Reinforcement (Rebar)",
            title: "Revit API Excel   Revit Integration",
            videoUrl:
                "https://www.youtube.com/embed/xR3YUdB4Khc?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=9\\&forigin=https%3A%2F%2Ffeesworth.com%2Fautodesk-revit-api-customization-automation-course%2F\\&vf=1"
        },
        {
            category: "Revit API Project Batch Sheet Generator",
            title: "Revit API Batch Sheet Generator",
            videoUrl:
                "https://www.youtube.com/embed/4pdczjF5xP4?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=11\\&forigin=https%3A%2F%2Ffeesworth.com%2Fautodesk-revit-api-customization-automation-course%2F\\&vf=1"
        }
    ]
};

export default RevitBimCourse;